import { Link } from 'react-router-dom';
import { categoryBrowsePath } from '../categoryPaths';
import { formatCount, shortCategoryName } from '../categoryLabels';
import { trackSelectCategory } from '../ga';

/**
 * Compact chip label for the homepage category rail.
 * @param {{ name?: string, slug?: string, priceCollection?: boolean }} category
 */
function categoryRailChipLabel(category) {
  if (category.priceCollection === true) {
    const slug = typeof category.slug === 'string' ? category.slug.toLowerCase() : '';
    if (slug === 'items-below-5') {
      return 'Below 5€';
    }
    if (slug === 'items-between-5-and-10') {
      return '5–10€';
    }
    const name = typeof category.name === 'string' ? category.name.trim() : '';
    return name !== '' ? name : shortCategoryName(category.name);
  }

  return shortCategoryName(category.name);
}

export function LandingCategoryChipRail({ categories, showDealsOfTheDay = false }) {
  const items = categories.filter((category) => {
    if (category.comingSoon === true) {
      return false;
    }
    const count = Number(category.count ?? category.productCount);
    return Number.isFinite(count) && count > 0;
  });

  const regularItems = items.filter((category) => category.priceCollection !== true);
  const priceItems = items.filter((category) => category.priceCollection === true);
  const orderedItems = [...regularItems, ...priceItems];

  if (orderedItems.length === 0 && !showDealsOfTheDay) {
    return null;
  }

  return (
    <nav className="landing-category-rail" aria-label="Browse categories">
      <div className="landing-category-rail__scroll-wrap">
        <div className="landing-category-rail__scroll">
          <div className="landing-category-rail__track">
          {showDealsOfTheDay && (
            <Link
              className="landing-category-rail__chip landing-category-rail__chip--deals"
              to="/deal-of-the-day"
              onClick={() => trackSelectCategory('deal-of-the-day', 'home_category_rail')}
            >
              <span className="landing-category-rail__chip-label">Today&apos;s deals</span>
            </Link>
          )}
          {orderedItems.map((category) => {
            const countLabel = formatCount(category.count ?? category.productCount);
            return (
              <Link
                key={category.slug}
                className="landing-category-rail__chip"
                to={categoryBrowsePath(category.slug)}
                onClick={() => trackSelectCategory(category.slug, 'home_category_rail')}
              >
                <span className="landing-category-rail__chip-label">
                  {categoryRailChipLabel(category)}
                </span>
                {countLabel && (
                  <span className="landing-category-rail__chip-count" aria-hidden="true">
                    {countLabel}
                  </span>
                )}
              </Link>
            );
          })}
          </div>
        </div>
      </div>
    </nav>
  );
}
